(function (EG) {
    'use strict';
    EG.Users.Profile.Models.CompanySSOSettings = EG.Users.Models.Base.extend({
        url: function () {
            return '/users/company-settings/' + this.companyId + '/' + this.code;
        },
        initialize: function (companyId, code) {
            this.companyId = companyId || undefined;
            this.code = code || undefined;
        }
    });
})(EG);
